import { render } from "./BMedia.vue?vue&type=template&id=54c08fd3"
import script from "./BMedia.vue?vue&type=script&lang=js"
export * from "./BMedia.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__